@if (isInline()) {
  <app-search-widget-v3-wrapper [isInline]="isInline()"></app-search-widget-v3-wrapper>
} @else {
  <app-search-widget-v3-placeholder>
    <app-search-widget-v3-wrapper [isInline]="isInline()" topwidget></app-search-widget-v3-wrapper>
  </app-search-widget-v3-placeholder>
}
